import React from "react";
import {DangerButton} from "../../../../components/CustomButton";
import CustomIcon from "../../../../components/CustomIcon";

export default function CarouselLoader({forceMobileVersion, showIndicators = true, aspectRatio, length}) {
  return (
    <div className="animate-pulse">
      <div className={`bg-rand-200 w-full image-aspect-ratio${forceMobileVersion ? ' force' : ''}`}
           style={{...(aspectRatio && {aspectRatio: `${aspectRatio}`})}}/>
      {showIndicators &&
        <div className="flex justify-center space-x-1 mt-1">
          {Array.from({length: length ?? 3}, (_, i) =>
            <CustomIcon key={`loader-carousel-${i}`} icon="circle" className="text-rand-200" size="xxs"/>)}
        </div>
      }


    </div>
  );
}

export function CarouselError({errorMsg, retry, aspectRatio}) {
  return (
    <div className="w-full flex justify-evenly flex-col bg-red-100 h-44 items-center"
         style={{...(aspectRatio && {aspectRatio: `${aspectRatio}`})}}>
      <div className="text-center text-lg text-error-500 whitespace-pre-wrap">{errorMsg}</div>
      <div className="text-center">
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>

    </div>
  );
}

export function CarouselNoData({msg}) {
  return (
    <div
      className="w-full flex items-center justify-center bg-secondary-300 h-44 text-rand-400 whitespace-pre-wrap text-center">
      {msg ? msg : 'No Data'}
    </div>
  );
}